export const generateGalleryAlt = (galleryTitle: string, models: { name: string }[] = [], tag?: string): string =>
  [galleryTitle, (tag && models.length > 0 ? [models[0]] : models).map((model) => model.name).join(' - '), tag]
    .filter((text) => text)
    .join(' - ');
